import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageLoader from '@/components/PageLoader';
import {
  isChunkLoadError,
  reloadForChunkError,
  shouldReloadForChunkError,
} from '@/lib/chunkLoad';

// Hata ekranı arama motoruna içerik olarak girmesin: Googlebot sayfayı bu
// durumda render ederse hata metni sayfanın başlığı/özeti olarak indeksleniyordu.
// noindex yalnızca bu ekran görünürken <head>'de durur.
const useNoIndex = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
};

export const ErrorScreen = ({ chunkError }: { chunkError: boolean }) => {
  const { t } = useTranslation();
  useNoIndex();

  return (
    <div className="flex min-h-[100lvh] items-center justify-center bg-[#03060f] px-6 text-center text-white">
      <div className="max-w-md">
        <h1 className="font-bricolage text-2xl font-bold">
          {t('common.reloadRequired')}
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-300">
          {chunkError ? t('common.chunkError') : t('common.unexpectedError')}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-6 rounded-full bg-[#3d84ff] px-5 py-2 text-sm font-bold text-white"
        >
          {t('common.refresh')}
        </button>
      </div>
    </div>
  );
};

// Rota errorElement'i — React Router'ın varsayılan "Unexpected Application
// Error!" ekranının yerine geçer. Chunk hatasında önce sayfayı bir kez taze
// yükler; bu sırada hata metni hiç çizilmez.
export const RouteError = () => {
  const error = useRouteError();
  const reload = shouldReloadForChunkError(error);

  useEffect(() => {
    if (reload) reloadForChunkError();
  }, [reload]);

  if (reload) return <PageLoader full />;
  return <ErrorScreen chunkError={isChunkLoadError(error)} />;
};
